<template>
    <div>
        <div class="text-center">
            <h2>Παναγιώτης Καλοζούμης</h2>
        </div>
        <v-container class="main-text text-container">
            <div>
                <v-img :width="415" :height="415" style="float: left;" class="bradius" :src="require('@/assets/partners/Photo-P-Kalozoumis.jpg')" />
                <p class="cv-text">
                    Ο Δρ. Παναγιώτης Καλοζούμης γεννήθηκε στην Αθήνα το 1994. Απέκτησε Ενιαίο Μεταπτυχιακό Δίπλωμα Γεωπονίας από το Γεωπονικό Πανεπιστήμιο Αθηνών (ΓΠΑ) το 2017. Το 2023 ολοκλήρωσε τη διδακτορική του διατριβή στο Εργαστήριο Κηπευτικών Καλλιεργειών (ΓΠΑ) υπό την επίβλεψη του Καθηγητή Δημητρίου Σάββα. Σήμερα εργάζεται ως μεταδιδακτορικός ερευνητής σε δύο ευρωπαϊκά προγράμματα, ECONUTRI (HORIZON) και InPlasTwin. Άλλες ερευνητικές συμμετοχές περιλαμβάνουν τα ευρωπαϊκά ερευνητικά προγράμματα TOMRES (HORIZON) και OPTIMUS. Η πτυχιακή του εργασία αφορούσε την καλλιέργεια κηπευτικών σε πράσινες στέγες, μια μελέτη που πραγματοποιήθηκε σε συνεργασία μεταξύ του Εργαστηρίου Κηπευτικών Καλλιεργειών και του Εργαστηρίου Ανθοκομίας &amp; Αρχιτεκτονικής Τοπίου του ΓΠΑ. Το ερευνητικό του έργο περιλαμβάνει 5 δημοσιεύσεις σε διεθνή επιστημονικά περιοδικά με κριτές και 4 δημοσιεύσεις σε πρακτικά εθνικών και διεθνών συνεδρίων με κριτές.
                </p>
                <p class="cv-text">
                    Παράλληλα διατηρεί τη δική του επιχείρηση, η οποία εστιάζει σε συμβουλευτικές υπηρεσίες για καλλιέργειες ανοιχτού αγρού και θερμοκηπίου, σχεδιασμό και κατασκευή τοπίου καθώς και υπηρεσίες φυτοπροστασίας. Τα ερευνητικά του ενδιαφέροντα περιλαμβάνουν τη θερμοκηπιακή και υπαίθρια παραγωγή κηπευτικών, τα συστήματα καλλιέργειας εκτός εδάφους, τη βιολογική παραγωγή, την αστική γεωργία κ.ά.
                </p>
                <p class="cv-text">
                    Το 2024 διετέλεσε Γραμματέας του Συμποσίου "I Int. Symposium on Protected Cultivation, Nettings and Screens for Mild Climates" στην Αθήνα, ενώ το 2026 ορίστηκε ως convener για το "III International Symposium on Growing Media, Compost Utilization and Substrate Analysis for Soilless Cultivation" το οποίο θα διεξαχθεί επίσης στην Αθήνα τον Σεπτέμβριο του 2027 μαζί με τον καθηγητή του Δημήτριο Σάββα.
                </p>
                <p class="cv-text contact-info">
                    <strong>Στοιχεία επικοινωνίας:</strong><br/>
                    e-mail: <a href="mailto:kalozoumis@aua.gr">kalozoumis@aua.gr</a><br/>
                    τηλέφωνο: 0030 6982863724<br/>
                    LinkedIn: <a href="https://www.linkedin.com/in/panagiotis-kalozoumis-443ba9289/" target="_blank">https://www.linkedin.com/in/panagiotis-kalozoumis-443ba9289/</a>
                </p>
            </div>
        </v-container>
    </div>
</template>

<script>
    export default {
        name: 'App',
        components: {
        },
        data: () => ({
        }),
        computed: {
        }
    }
</script>
<style scoped>
.cv-card {
    border: 1px solid #D9D9D9;
    border-radius: 25px;
    text-align: center;
}
.bradius {
    border-radius: 25px;
    margin-right: 15px;
}
.cv-text {
    display: inline;
}
.main-text {
    width: 90%;
    max-width: 900px;
    margin: auto;
    color: #646464;
}
.contact-info {
    display: block;
    margin-top: 15px;
}

@media (max-width: 600px) {
    .bradius {
        float: none !important;
        display: block;
        margin: 0 auto 15px !important;
        max-width: 280px;
    }
}
</style>
